export var skipToken = Symbol.for("apollo.skipToken");
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/react/hooks/constants.js
// module id = 1115
// module chunks = 11